import React, { useEffect } from 'react';
import { FormGroup, Label, Input, } from 'reactstrap';
import { omit, isEmpty } from 'lodash';
import { toast } from 'react-toastify';

import { prefectures, } from '../../shared/config';
import { fields } from '../../shared/models/destination';
import { getAddressByPostalCode, } from '../../util';
import useCollectionSubscription from '../hooks/useCollectionSubscription';
import ModelFormModal from '../modals/ModelFormModal';
import Page from '../hocs/Page';
import AddButton from '../AddButton';
import EditButton from '../EditButton';
import DeleteButton from '../DeleteButton';
import SettingsTabs from '../SettingsTabs';

const { entries } = Object;

export default Page(function SettingsDestinations (props) {
  const { tenant } = props;
  const destinationsRef = tenant.ref.collection('destinations');
  const destinations = useCollectionSubscription(destinationsRef.orderBy('createdAt'), [tenant.id]);
  const onFormStateChanged = (prevStatedFields, statedFields) => {
    if(!prevStatedFields) return;
    if(prevStatedFields.postalCode.value === statedFields.postalCode.value) return;
    if(!statedFields.postalCode.isValid) return;

    (async () => {
      const [data] = await getAddressByPostalCode(statedFields.postalCode.value);
      data && statedFields.setValues(omit(data, 'address1'));
    })();
  };

  return (
    <div className="settings-destinations container-fluid">
      <div className="p-4 bg-white my-4">
        <SettingsTabs activeTab="destinations" />
        <div className="d-flex justify-content-start mb-3">
          <AddButton itemRef={destinationsRef.doc()} FormModal={ModelFormModal} formProps={{ title: '配送先 追加', fields, onStateChanged: onFormStateChanged, }} />
        </div>
        <div className="mt-3 overflow-auto">
          {
            destinations.length > 0 ? (
              <table className="table sticky-table table-sm table-bordered">
                <thead className="thead-light text-center">
                  <tr className="text-nowrap">
                    <th style={{ minWidth: 200 }}>郵便番号</th>
                    <th style={{ minWidth: 120 }}>都道府県</th>
                    <th style={{ minWidth: 150 }}>市区郡町村</th>
                    <th style={{ minWidth: 150 }}>町・番地</th>
                    <th style={{ minWidth: 150 }}>マンション・ビル名</th>
                    <th style={{ minWidth: 200 }}>氏名</th>
                    <th style={{ minWidth: 200 }}>電話番号</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {
                    destinations.map((destination) => {
                      const { id, ref, postalCode, prefecture, city, address1, address2, name, phone, } = destination;

                      return (
                        <tr key={id}>
                          <td>
                            {postalCode}
                          </td>
                          <td>
                            {prefectures[prefecture]}
                          </td>
                          <td>
                            {city}
                          </td>
                          <td>
                            {address1}
                          </td>
                          <td>
                            {address2}
                          </td>
                          <td>
                            {name}
                          </td>
                          <td>
                            {phone}
                          </td>
                          <td className="text-right text-nowrap">
                            <EditButton className="ml-2" itemRef={ref} FormModal={ModelFormModal} formProps={{ title: '配送先 編集', fields, onStateChanged: onFormStateChanged, }} />
                            <DeleteButton item={destination} itemRef={ref} className="ml-2" />
                          </td>
                        </tr>
                      );
                    })
                  }
                </tbody>
              </table>
            ) : (
              <div>
                配送先は未登録です
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
});
